import { useEffect, useState } from 'react';
import { base44 } from '@/api/base44Client';

// Outstanding work behind the consolidated CRM sidebar links: RMA requests
// still awaiting a decision, and customer reviews still awaiting moderation.
// Both are read from the same entities the pages themselves use, and kept
// current through the entity subscription rather than polling. Returns zeros
// for non-admins (both entities are admin-only).
export default function useSupportBadges(enabled = true) {
  const [counts, setCounts] = useState({ rma: 0, reviews: 0 });

  useEffect(() => {
    if (!enabled) {
      setCounts({ rma: 0, reviews: 0 });
      return;
    }
    let cancelled = false;

    const load = async () => {
      try {
        const [rmas, reviews] = await Promise.all([
          base44.entities.RmaRequest.filter({ status: 'pending' }),
          base44.entities.Review.filter({ status: 'pending' }),
        ]);
        if (!cancelled) {
          setCounts({ rma: rmas?.length || 0, reviews: reviews?.length || 0 });
        }
      } catch {
        if (!cancelled) setCounts({ rma: 0, reviews: 0 });
      }
    };

    load();
    const unsubRma = base44.entities.RmaRequest.subscribe(() => load());
    const unsubReviews = base44.entities.Review.subscribe(() => load());
    return () => {
      cancelled = true;
      if (typeof unsubRma === 'function') unsubRma();
      if (typeof unsubReviews === 'function') unsubReviews();
    };
  }, [enabled]);

  return counts;
}